import { type ContractDto } from '@b-stock/contract-api-client'
import { CurrencyStringCents } from '@b-stock/fe-core/bstock-react'

import { ContractBidFulfillmentUnit } from './ContractBidFulfillmentUnit'

export const ContractEstimatedMSRP = ({
  value,
  contract,
  currency = 'USD',
}: {
  value: number
  contract: ContractDto
  currency?: string
}) => {
  return (
    <>
      <CurrencyStringCents currency={currency} value={value} />
      {' /'}
      <ContractBidFulfillmentUnit contract={contract} />
    </>
  )
}
